import { createAnimations } from '@tamagui/animations-css'


export const animations = createAnimations({
  bouncy: 'ease-in 150ms',
  lazy: 'ease-in 300ms',
  quick: 'ease-in-out 150ms',
  normal: 'ease-in 200ms',
  "page-slide": 'cubic-bezier(0.165, 0.840, 0.440, 1.000) 500ms'
})